import {Box} from "@mui/material";
import Header from "./Header";

const Layout = ({children}) => {
  return (
    <Box sx={{display: "flex", flexDirection: "column", minHeight: "100vh"}}>
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          p: 3
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
